// 用户信息接口
import http from '@/utils/network/general/http'

// 获取指定用户信息
export function getUserInfo (params) {
  return http.get('/UserInfo/GetUserInfo', params)
}

// 获取所有用户列表
export function getUsers (params) {
  return http.get('/UserInfo/GetUsers', params)
}

// 修改密码
export function changePwd (data) {
  return http.post('/UserInfo/ChangePwd', data)
}
